import { ExamLogType } from '../../model/exam/log/exam-log-type.enum';

export class ExamLogEntity {
    public message!: string;
    public type!: ExamLogType;
    public loggedDate!: Date;
}
